export default "__VITE_ASSET__Cn9soE1W__"